import { render } from "./V2ResearchModel.vue?vue&type=template&id=e48de61e&scoped=true"
import script from "./V2ResearchModel.vue?vue&type=script&lang=js"
export * from "./V2ResearchModel.vue?vue&type=script&lang=js"

import "./V2ResearchModel.vue?vue&type=style&index=0&id=e48de61e&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48de61e"]])

export default __exports__